import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Globe } from 'lucide-react';

export const LanguageSelector = ({ className = '', showLabel = false, allowedLanguages }) => {
  const { currentLanguage, changeLanguage, languages } = useLanguage();
  const visibleLanguages = allowedLanguages
    ? languages.filter((language) => allowedLanguages.includes(language.code))
    : languages;
  const selectedLanguage = visibleLanguages.some((language) => language.code === currentLanguage)
    ? currentLanguage
    : visibleLanguages.find((language) => language.code === 'en')?.code
      || visibleLanguages[0]?.code
      || currentLanguage;

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {showLabel && <Globe className="w-4 h-4 text-slate-500" />}
      <Select value={selectedLanguage} onValueChange={changeLanguage}>
        <SelectTrigger className="w-[140px]" data-testid="language-selector">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {visibleLanguages.map((lang) => (
            <SelectItem key={lang.code} value={lang.code}>
              <span className="flex items-center gap-2">
                <span>{lang.flag}</span>
                <span>{lang.name}</span>
              </span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default LanguageSelector;
